export * from './SignUpFormsFields';
export * from './TransportationArrivals';
export const INCREASE = 'INCREASE';
export const DECREASE = 'DECREASE';
export const videoExtensions =
    '.+.(webm|mkv|flv|vob|ogg|ogv|drc|gif|avi|mov|mp4|m4p|m4v|mpg|mp2|mpeg|mpe|mpv|3gp|3g2|mxf)';
export const walkMeEnvironmentMap = {
    t1: '/lowertest',
    t2: '/lowertest',
    t3: '/lowertest',
    t4: '/lowertest',
    t4b: '/lowertest',
    c1: '/test',
    c2: '/wyndhamtest',
    p1: '',
    p2: '/wyndhamprod',
    p4: ''
};

export const themeOrConfigCodeSanitizeRegex = /[^a-zA-Z0-9_\-\. ]/;

export const DISALLOWED_CONFIG_OR_THEME_CODES = ['systemDefault']


// WEBPACK FOOTER //
// ./src/constants/index.js